import { E_LegendIconType } from "../../../../../enums/smart-display/graphs/legend-icon-type.enum";
import { I_ChartSettings, I_LegendLayoutConfigDto, I_LegendLayoutRowDto, I_LegendLayoutColumnDto, I_LegendLabelDto } from "../api/chart-cell-config.response";

export class C_ChartSettings {
    legendLayoutConfig?: C_LegendLayoutConfig;
    legendGrowPriority?: number;
    chartGrowPriority?: number;
    needRequestGroup: boolean = true;

    constructor(data?: I_ChartSettings) {
        if (!data) return;
        this.initialize(data);
    }

    initialize(data: I_ChartSettings) {
        if (data.legendLayoutConfig) this.legendLayoutConfig = new C_LegendLayoutConfig(data.legendLayoutConfig);
        if (data.legendGrowPriority !== null && data.legendGrowPriority !== undefined) this.legendGrowPriority = data.legendGrowPriority;
        if (data.chartGrowPriority !== null && data.chartGrowPriority !== undefined) this.chartGrowPriority = data.chartGrowPriority;
        if (data.needRequestGroup !== null && data.needRequestGroup !== undefined) this.needRequestGroup = data.needRequestGroup;
    }
}


export class C_LegendLayoutConfig {
    rows: C_LegendLayoutRow[] = [];

    constructor(json?: I_LegendLayoutConfigDto) {
        if (!json) return;
        if (json.rows) {
            json.rows.forEach((row) => {
                this.rows.push(new C_LegendLayoutRow(row));
            });
        }
    }
}

export class C_LegendLayoutRow {
    growPriority?: number;
    columns: C_LegendLayoutColumn[] = [];

    constructor(json?: I_LegendLayoutRowDto) {
        if (!json) return;
        if (json.growPriority != null && json.growPriority != undefined) this.growPriority = json.growPriority;
        if (json.columns) {
            json.columns.forEach((column) => {
                this.columns.push(new C_LegendLayoutColumn(column));
            });
        }
    }
}

export class C_LegendLayoutColumn {
    key: string = '';
    hasCheckBox: boolean = false;
    growPriority?: number;
    label?: C_LegendLabel;

    constructor(json?: I_LegendLayoutColumnDto) {
        if (!json) return;
        if (json.key) this.key = json.key;
        this.hasCheckBox = !!json.hasCheckBox;
        if (json.growPriority != null && json.growPriority != undefined) this.growPriority = json.growPriority;
        if (json.label) this.label = new C_LegendLabel(json.label);
    }
}

export class C_LegendLabel {
    id: string = '';
    name?: string;
    colorLabel?: string;
    showSymbol?: boolean;
    colorIcon?: string;
    iconType: E_LegendIconType = E_LegendIconType.HorizontalLine;

    constructor(json?: I_LegendLabelDto) {
        if (!json) return;
        if (json.id) this.id = json.id;
        if (json.name) this.name = json.name;
        if (json.colorLabel) this.colorLabel = json.colorLabel;
        if (json.showSymbol != null) this.showSymbol = json.showSymbol;
        if (json.colorIcon) this.colorIcon = json.colorIcon;
        if (json.iconType) this.iconType = json.iconType;
    }
}